import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { PROPERTY_EDIT_PAGE_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';
import { RouteRecordRaw } from 'vue-router';

const routes: LocalizedRoutes = {
  de: { path: PROPERTY_EDIT_PAGE_PATH.de, meta: { requiresAuth: true } },
  en: { path: PROPERTY_EDIT_PAGE_PATH.en, meta: { requiresAuth: true } },
  fr: { path: PROPERTY_EDIT_PAGE_PATH.fr, meta: { requiresAuth: true } },
  it: { path: PROPERTY_EDIT_PAGE_PATH.it, meta: { requiresAuth: true } },
};

const Component = () =>
  import('@/components/property-details-page/ValuationForm/ValuationForm.vue');

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(routes, Component, Pages.PropertyEdit);

export default localizedRouteConfig;
